import { formatCredits } from '../utils/format'

/** "~120 cr" next to a paid action; nothing until the estimate is known. */
export function Cost({ micro }: { micro: number | undefined }) {
  if (micro == null) return null
  return (
    <span className="cost" title="Estimated credits">
      ~{formatCredits(micro, 'up')} cr
    </span>
  )
}
